import $ from "jquery";
window.$ = $;
window.jQuery = $;

let posStepFixed, maxScroll, hHeader;

$(window).bind("load resize", function () {
    const $stepMenu = $(".jsFixesStep");
    if ($stepMenu.length) {
        hHeader = $("#header").outerHeight() || 0;
        const windowWidth = $(window).width();
        const isMobile = windowWidth <= 768;
        $stepMenu.removeClass("fixed bottom").css({ "top": "", "width": "" });
        const offsetPadding = isMobile ? 10 : 40;
        const menuHeight = $stepMenu.outerHeight();
        const $container = $stepMenu.parent();
        posStepFixed = $stepMenu.offset().top - hHeader - offsetPadding;
        maxScroll = $container.offset().top + $container.height() - menuHeight - hHeader - offsetPadding;
        if (!isMobile) {
            $stepMenu.css("width", $container.width() + "px");
        }
    }
});

$(window).bind("scroll", function () {
    const $stepMenu = $(".jsFixesStep");
    if ($stepMenu.length) {
        const scroll = $(window).scrollTop();
        const isMobile = $(window).width() <= 768;
        if (scroll <= posStepFixed) {
            $stepMenu.removeClass("fixed bottom").css("top", "");
        } else if (scroll >= maxScroll) {
            $stepMenu.removeClass("fixed").addClass("bottom").css("top", "");
        } else {
            const pcTop = hHeader + 20;
            $stepMenu.addClass("fixed").removeClass("bottom").css("top", (isMobile ? hHeader : pcTop) + "px");
        }
    }
});

$(document).on("click", ".jsFixesStep a", function (e) {
    const targetId = $(this).attr("href");
    if (targetId && targetId.startsWith("#")) {
        const $target = $(targetId);
        if ($target.length) {
            e.preventDefault();
            const isMobile = $(window).width() <= 768;
            const $stepMenu = $(".jsFixesStep");
            const currentHeaderH = $("#header").outerHeight() || 0;
            let scrollTarget = $target.offset().top - currentHeaderH;
            if (isMobile) {
                const menuHeight = $stepMenu.outerHeight() || 0;
                if (!$stepMenu.hasClass("fixed")) {
                    scrollTarget -= (menuHeight + 70);
                } else {
                    scrollTarget -= (menuHeight + 10);
                }
            } else {
                scrollTarget -= 10;
            }
            $("html, body").stop().animate({
                scrollTop: scrollTarget
            }, 500);
        }
    }
});
